/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-10-17 21:48:20
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";

import "./index.css";
import BsyMsgBubble from "../BsyMsgBubble";

export default class BsySubformBase extends BsyWidget {
  constructor(props) {
    super({
      ...props,
    });
  }

  popUpPaneClose = (e) => {
    if (
      e &&
      e.target &&
      e.target.classList.contains("icon-dingding-guide-close")
    ) {
      this.value = null;
      this.setState(
        {
          value: this.value,
        },
        () => {
          BsyUtils.applyFunc(
            this,
            this.props.onStopEdit,
            [this.value, null, this],
            !1
          );
        }
      );
    }
    return !1;
  };

  _onTriggerClick = (event, width) => {
    let that = this;
    this.isEditd = false;
    this.bubble = null;

    let popupWidth =
      width ||
      (event.currentTarget.offsetWidth < 150
        ? 150
        : event.currentTarget.offsetWidth);

    let minWidth =
      width || event.currentTarget.offsetWidth < 150
        ? 150
        : event.currentTarget.offsetWidth;
    this.hasFocus = true;
    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        that.bubble = ref;
        return this.popUpPane();
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: minWidth,
      width: popupWidth,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function (e) {
        that.hasFocus = false;
        let ret = that.popUpPaneClose(e);
        that.bubble = null;
        return ret;
      },
    });
  };

  render() {
    return <></>;
  }
}
